import React from 'react';
import { useApp } from '@/contexts/AppContext';

export default function StatusBar() {
  const { seed } = useApp();
  const ps = seed?.platform_status;
  if (!ps) return null;
  return (
    <div data-testid="status-bar" className="border-t border-slate-200 bg-white/80 backdrop-blur px-4 sm:px-6 py-2 flex items-center justify-between text-[11px] font-mono text-apex-neutral">
      <div className="hidden sm:flex items-center gap-3">
        <span className="inline-flex items-center gap-1.5">
          <span className="relative inline-block w-2 h-2 rounded-full bg-apex-success">
            <span className="absolute inset-0 rounded-full bg-apex-success animate-ping opacity-60" />
          </span>
          Live
        </span>
        <span>·</span>
        <span>Last ingested: {ps.last_ingested_minutes} minutes ago</span>
        <span>·</span>
        <span>{ps.accounts_monitored} accounts</span>
        <span>·</span>
        <span>{ps.event_coverage_pct}% event coverage</span>
        <span>·</span>
        <span>Evidence fabric {ps.fabric_health}</span>
      </div>
      <div className="sm:hidden flex items-center gap-2">
        <span className="inline-flex items-center gap-1.5">
          <span className="relative inline-block w-2 h-2 rounded-full bg-apex-success">
            <span className="absolute inset-0 rounded-full bg-apex-success animate-ping opacity-60" />
          </span>
          Live
        </span>
        <span>· {ps.last_ingested_minutes} min ago</span>
        <span>· {ps.event_coverage_pct}% coverage</span>
      </div>
      <div className="hidden md:block text-[10px] uppercase tracking-wider">v{ps.version} · {ps.tier}</div>
    </div>
  );
}
